import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "../../../utils/apiPath";
import { agent } from "../../../utils/agent";

export const getSettingData = createAsyncThunk(
    "setting/getSettingData",
    async () => {
        try {
            const response = await agent.get(API.SETTING);
            return response?.data?.data;
        } catch (error) {
            return (error.response?.data?.message || 'Failed to load advisors data');
        }
    }
);

export const sendEmailForVerification = createAsyncThunk(
    "setting/sendEmailForVerification",
    async (data) => {
        try {
            const response = await agent.post(API.SEND_EMAIL_FOR_VERIFICATION, data);
            return response.data;
        } catch (error) {
            return (error.response?.data?.message || "Failed to send message");
        }
    }
);

const footerSlice = createSlice({
    name: "footer",
    initialState: {
        data: {},
        loading: false,
        emailStatus: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Get settings
            .addCase(getSettingData.pending, (state) => {
                state.loading = true;
            })
            .addCase(getSettingData.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(getSettingData.rejected, (state) => {
                state.loading = false;
            })

            // Email verification
            .addCase(sendEmailForVerification.fulfilled, (state, action) => {
                state.emailStatus = action.payload;
            });
    },
});

export default footerSlice.reducer;
